<script setup>
import HelpIcon from '~icons/tabler/x'
import { onClickOutside } from '@vueuse/core'
import { onMounted, computed, ref } from 'vue'
import useHuggy from '@/data/composables/useHuggy'
const huggy = useHuggy()

const target = ref(null)

const chatVisible = computed(() =>
  document.querySelector('.powerzap_chat_canvas.opened'),
)

onClickOutside(target, () => {
  huggy.closeChat()
})

onMounted(() => {
  huggy.loadScript()
})
</script>
<template>
  <div ref="target">
    <VBtn
      v-if="chatVisible"
      class="!tw-fixed tw-right-4 tw-bottom-4"
      density="compact"
      :prepend-icon="HelpIcon"
      @click="huggy.closeChat"
      :flat="false"
      height="38"
      rounded
      >Fechar chat</VBtn
    >
  </div>
</template>
